/**
 * Slice C.1 · NarrationBlock — default fallback renderer.
 * Shows the server-authored narration as a single paragraph.
 * No fabrication, no derivation.
 */
export function NarrationBlock({ presentation }) {
  return (
    <p
      data-testid="ui-response-narration"
      className="text-[14px] leading-relaxed text-zinc-100"
    >
      {presentation.narration}
    </p>
  );
}

export default NarrationBlock;
